import React from 'react'
import { AvatarContainer, Picture, ProfileIcon, Wrapper } from './styles'
import { composeInitialsName } from '../../utils'

type Props = {
  'data-qa'?: string
  names: string[]
  hasPicture?: boolean
  theme?: 'circle' | 'square'
}

const AvatarList: React.FC<Props> = (props: Props): JSX.Element => {
  const dataQa = props['data-qa']

  return (
    <Wrapper>
      {props.names.map((name, index) => (
        <AvatarContainer key={index} data-qa={dataQa}>
          {props.hasPicture ? (
            <Picture src={name} className={props.theme} />
          ) : (
            <ProfileIcon className={props.theme}>
              <div>
                <span>{composeInitialsName(name)}</span>
              </div>
            </ProfileIcon>
          )}
        </AvatarContainer>
      ))}
    </Wrapper>
  )
}

AvatarList.defaultProps = {
  names: [''],
  hasPicture: false,
  theme: 'circle',
}

export default AvatarList
